var _templateObject, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import styled from '@emotion/styled';
import MUISvgIcon, { svgIconClasses } from '@mui/material/SvgIcon';
import * as React from "react";
var SvgIcon = styled(MUISvgIcon)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  &.", " {\n    width: ", ";\n    height: ", ";\n    color: ", ";\n    stroke-width: 1px;\n    vector-effect: non-scaling-stroke;\n  }\n"])), svgIconClasses.root, function (_ref) {
  var size = _ref.size,
    theme = _ref.theme;
  return size && theme.size[size];
}, function (_ref2) {
  var size = _ref2.size,
    theme = _ref2.theme;
  return size && theme.size[size];
}, function (_ref3) {
  var color = _ref3.color,
    theme = _ref3.theme;
  return color && theme.color[color];
});
var SvgBoost = function SvgBoost(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 33"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    y: 0.635,
    fill: "#6EB171",
    rx: 16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2E442E",
    d: "M20.664 14.635h-3.333v-4c0-.2-.134-.4-.267-.533-.267-.2-.733-.133-.933.133l-5.334 7.334c-.066.133-.133.266-.133.4 0 .4.267.666.667.666h3.333v4c0 .4.267.667.667.667.2 0 .4-.133.533-.267l5.333-7.333c.067-.133.134-.267.134-.4 0-.4-.267-.667-.667-.667"
  }))));
};
export default SvgBoost;